import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Box, Typography } from '@mui/material';
import type { FC } from 'react';

import WarningIcon from 'components/Icons/WarningIcon';

export type StatusType = 'success' | 'error' | 'warning';

interface StatusMessageBoxProps {
  type: StatusType;
  message: string;
  description?: string;
  margin?: string;
}

const StatusMessageBox: FC<StatusMessageBoxProps> = ({
  type = 'success',
  message,
  description,
  margin = '50px 20px',
}) => {
  const iconMap = {
    success: (
      <CheckCircleOutlineRoundedIcon color="success" sx={{ fontSize: 80 }} />
    ),
    error: <ErrorOutlineRoundedIcon color="error" sx={{ fontSize: 80 }} />,
    warning: <WarningIcon sx={{ fontSize: 80, color: '#FFCC00' }} />,
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      height="100%"
      sx={{ overflowY: 'auto' }}
      data-testid={`${type}-box`}
    >
      <Box
        margin={margin}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        {iconMap[type]}
        <Typography
          variant="h2"
          mt={4}
          mb={1}
          textAlign="center"
          data-testid={`${type}-message`}
          fontWeight={600}
        >
          {message}
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          data-testid={`${type}-description`}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatusMessageBox;
